// extracted by mini-css-extract-plugin
export var cardStats = "CardStats_cardStats__GD-b3";
export var statsGrid = "CardStats_statsGrid__+YEvz";
export var btnWrapper = "CardStats_btnWrapper__xIyYC";
export var rotate = "CardStats_rotate__0p3tY";
export var dotty = "CardStats_dotty__7Zys-";